module.exports = __webpack_public_path__ + "static/img/xiaoguidongtai.a40751d.png";